export function formatDateWithouthHourConditional(date) {
    if (date) {
        const d = new Date(date);
        let month = '' + (d.getMonth() + 1);
        let day = '' + d.getDate();
        const year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    } else
        return undefined;
}


// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/theme/functions/formatDateWithouthHourConditional.function.ts